import React from 'react';
import { ComplianceCard } from './ComplianceCard';
import { FileTextIcon, ToggleLeftIcon, SearchIcon, UserIcon, ShieldAlertIcon, PhoneIcon } from 'lucide-react';
export const ComplianceGrid = () => {
  const modules = [{
    title: 'Privacy Policy',
    description: 'Your policy is up to date with DPDP requirements',
    status: 'completed' as const,
    icon: FileTextIcon,
    action: {
      label: 'View/Edit Policy',
      onClick: () => console.log('View/Edit Policy')
    }
  }, {
    title: 'Consent Manager',
    description: 'Action needed: Set up consent collection forms',
    status: 'warning' as const,
    icon: ToggleLeftIcon,
    action: {
      label: 'Set up now',
      onClick: () => console.log('Set up Consent Manager')
    }
  }, {
    title: 'Data Discovery',
    description: 'Scanning 3 databases... 65% complete',
    status: 'in-progress' as const,
    icon: SearchIcon,
    action: {
      label: 'View Progress',
      onClick: () => console.log('View Data Discovery')
    }
  }, {
    title: 'DSR Portal',
    description: '2 pending subject requests',
    status: 'warning' as const,
    icon: UserIcon,
    action: {
      label: 'Handle Requests',
      onClick: () => console.log('Handle DSR')
    }
  }, {
    title: 'Risk & Alerts',
    description: '3 potential vulnerabilities detected',
    status: 'warning' as const,
    icon: ShieldAlertIcon,
    action: {
      label: 'Review Alerts',
      onClick: () => console.log('Review Alerts')
    }
  }, {
    title: 'Grievances',
    description: 'No active grievances',
    status: 'completed' as const,
    icon: PhoneIcon,
    action: {
      label: 'Open Portal',
      onClick: () => console.log('Open Grievances')
    }
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-41">
      {modules.map((module, index) => <ComplianceCard key={index} {...module} data-id="element-42" />)}
    </div>;
};